<template>
  <div class="black--background mt-10 pt-3">
    <v-container class="full-screen-app-bar-footer">
      <v-row class="mb-3">
        <v-col cols="12" sm="6" md="4" lg="3" style="position: relative" :class="{ 'pr-8': $vuetify.breakpoint.mdAndUp }">
          <FooterMainMenuCard :items="menus" :optional-sort="siteMenu" @onClick="menuRouteHandler"
            @onClickSubMenu="menuRouteHandler"></FooterMainMenuCard>
          <!--          <FooterMainMenuCard-->
          <!--                  class="mt-n5"-->
          <!--                  v-if="siteMenu"-->
          <!--                  :api="true"-->
          <!--                  :items="siteMenu"-->
          <!--                  @onClick="menuRouteHandler"-->
          <!--                  @onClickSubMenu="menuRouteHandler"-->
          <!--          ></FooterMainMenuCard>-->
          <div class="hidden-sm-and-down newsletter-social">
            <GreenButton width="200px" class="newsletter-label-max-width mb-5" label="E-newsletter"
              @onPress="gotoEnewsletter" />
            <v-layout px-1>
              <v-flex shrink mr-5 v-for="(item, i) in social" :key="i">
                <v-img eager alt="tcdc-social" contain width="33px" height="33px" style="border-radius: 100%;"
                  class="cursor-pointer" :src="item.icon" @click="socialClick(item)"></v-img>
              </v-flex>
            </v-layout>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="8" lg="9" :class="{ 'pl-8': $vuetify.breakpoint.mdAndUp }">
          <v-row :class="{ 'card-minus-margin': $vuetify.breakpoint.mdAndUp }">
            <template v-for="(item, index) of menuList">
              <v-col cols="12" sm="12" md="6" lg="4" v-if="item.menuNameList.length > 0" :key="index"
                :class="{ 'pr-8': $vuetify.breakpoint.mdAndUp }">
                <FooterMenuCard :title="item[`title_${lang}`]" :items="item.menuNameList"
                  @onClickHeader="menuHeaderHandler" @onClick="menuRouteHandler" @onClickSubMenu="menuRouteHandler">
                </FooterMenuCard>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up pt-0">
          <GreenButton width="200px" class="newsletter-label-max-width mb-5" label="E-newsletter"
            @onPress="gotoEnewsletter" />
          <v-layout px-1>
            <v-flex shrink mr-5 v-for="(item, i) in social" :key="i">
              <v-img eager alt="tcdc-social" contain width="33px" height="33px" style="border-radius: 100%;"
                class="cursor-pointer" :src="item.icon" @click="socialClick(item)"></v-img>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown" class="px-3 pb-3">
        <v-flex sm12 md6>
          <v-layout justify-start>
            <v-flex shrink v-for="(item, i) in ref_logo" :key="i">
              <v-img eager alt="tcdc-ref" width="75px" contain class="cursor-pointer mr-5" :src="item.icon"
                @click="routeTo(item.name)"></v-img>
            </v-flex>
          </v-layout>
        </v-flex>
        <!--        <v-col xl="6" lg="6" md="6" sm="12" cols="12">-->

        <!--        <v-layout>-->
        <!--          <v-flex shrink v-for="(item, i) in policy "  class=" justify-xl-end justify-start"  :key="i">-->
        <!-- <v-flex shrink class="d-flex justify-start justify-lg-end mx-3 text-end">
          <span v-for="(item, i) in policy " :key="i" class="white--text">
            <br />
            <span v-if="i > 0" class=" mx-2">|</span>
            <a @click="gotoPolicy(item.link)" class="link">{{ item.name }}</a>
          </span>
        </v-flex> -->
        <v-flex shrink class="d-flex justify-start justify-lg-end mx-3 text-end">
          <span v-for="(item, i) in this.lang === 'th' ? policyTh : policyEn" :key="i" class="white--text">
            <br />
            <span v-if="i > 0" class=" mx-2">|</span>
            <a @click="gotoPolicy(item.link)" class="link">{{ item.name }}</a>
          </span>
        </v-flex>

        <!--            &lt;!&ndash;            <v-img&ndash;&gt;-->
        <!--            &lt;!&ndash;                width="75px"&ndash;&gt;-->
        <!--            &lt;!&ndash;                contain&ndash;&gt;-->
        <!--            &lt;!&ndash;                class="cursor-pointer mr-5"&ndash;&gt;-->
        <!--            &lt;!&ndash;                :src="item.icon"&ndash;&gt;-->
        <!--            &lt;!&ndash;                @click="routeTo(item.name)"&ndash;&gt;-->
        <!--            &lt;!&ndash;            ></v-img>&ndash;&gt;-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
        <!--        </v-col>-->

      </v-layout>
      <!--      <v-row class="px-3 pb-3">-->

      <!--      </v-row>-->
      <v-row class="my-0 pa-3 ">
        <v-layout justify-start class="white--text" style="font-size: 12px;margin-left: 12px ">
          Copyright © 2017 TCDC (Thailand Creative & Design Center). All rights reserved.
        </v-layout>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FooterMenuCard from "./FooterMenuCard";
import FooterMainMenuCard from "./FooterMainMenuCard";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';
import { Utils } from "@/util/Utils";

export default {
  // created() {
  //   path: `/about-main`,
  //     console.log("banana");
  //   const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
  //   console.log(branch);
  // },
  methods: {
    loadDynamicMenusWithBranch() {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      console.log(branch);
      this.menus = [
        {
          name: "appbar.about",
          path: `/about-main`,
          branch_id: this.branchId
        },
        {
          name: "appbar.resourceCenter",
          subMenuList: [
            { name: "resourceCenter.article", path: `${branch}` + "/service/resource-center/article" },
            { name: "resourceCenter.ebook", path: `${branch}` + "/service/resource-center/e-book" },
            {
              name: "resourceCenter.onlineEx",
              path: `${branch}` + "/service/resource-center/online-exhibition"
            },
            {
              name: "design world calendar",
              path: `${branch}` + "/service/resource-center/design-world-calendar"
            }
          ]
          // path: "/service/resource-center"
        },
        // {
        //   name: "my tcdc",
        //   website: "https://my.tcdc.or.th/"
        // },
        // {
        //   name: "network"
        // },
        {
          name: "appbar.career",
          website: "https://www.cea.or.th/th/career"
        },
        {
          name: "appbar.faqs",
          path: "/faqs"
        },
        {
          name: 'footer.news',
          path: "/all/about/news"
        }
      ]
    },
    gotoEnewsletter() {
      if (this.$route.path !== '/enewsletter') {
        this.$router.push(`/${this.lang}` + '/enewsletter');
      } else {
        this.$vuetify.goTo('#enewsletter');
      }
    },
    routeTo(web) {
      switch (web) {
        case 'cea':
          window.open('https://cea.or.th/');
          break;
        case 'gov':
          window.open('http://www.opm.go.th/opmportal/default.asp');
          break;
        case 'tcdc':
          window.open('http://www.tcdc.or.th/');
          break;
      }
    },
    menuHeaderHandler() {
      this.$router.push(`/${this.lang}` + "/home");
    },
    async menuRouteHandler(item) {
      const website = item.website;
      const path = item.path;
      const branch = item.branch_id;
      const _this = this;
      function routerPush(url, branch_id) {
        // loaded
        _this.isLoading = false;
        let name = Utils.getBranchNameById(branch_id, _this.allBranches);
        if (url == '/faqs') {
          _this.$router.push(url).catch(() => { })
        } else {
          _this.$router.push(`/${_this.lang}` + url).catch(() => { })
        }
        // let pushUrl;
        // if (url.includes('resource-center') && !!name) {
        //   pushUrl = url.replace(name, '');
        //   _this.$router.push(pushUrl).catch(()=>{});
        // } else if (name && !url.includes(name)) {
        //   pushUrl = url + name;
        //   _this.$router.push(pushUrl).catch(()=>{})
        // } else {
        //   _this.$router.push(url).catch(()=>{})
        // }
      }

      if (item.name === 'about') {
        // loading
        this.isLoading = true;
        if (this.branchId === 0 || path.indexOf('about-main') > -1) {
          // all branches go to about-main
          let ab = { branch_id: 0, lang: this.lang };
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", ab)
          await this.$store.dispatch("Branch/getBranchById", 0)
          routerPush(path)
        } else {
          const dataParams = { branch_id: this.branchId, lang: this.lang };
          if (this.branchId === 5) {
            await this.$store.dispatch('Branch/getMiniByBranch', dataParams);
          }
          await this.$store.dispatch("About/getAboutAllMenu", dataParams);
          return await this.$store.dispatch("About/getAboutById", {
            id: this.branchId,
            lang: this.lang
          }).then(async res => {
            if (res.response_code == 200) {
              //set about data in form
              await this.$store.dispatch("About/setFormAbout", res.result);
              this.isLoading = false;
              // if (template_id === 3) {
              if (this.branchId === 5) {
                return this.$router.push(`/${this.lang}` + `/mini-tcdc/about/mini-tcdc`);
              } else {
                for (const b of this.allBranches) {
                  if (res.result.branch_id === b.branch_id) {
                    return this.$router.push(`/${this.lang}` + `/${b.tag_name}/about`);
                  }
                }
              }
            } else {
              alert('data not found');
              this.isLoading = false;
            }
          })
        }
      }

      if (item.name === 'network') {
        // loading
        this.isLoading = true;
        this.$store.dispatch("About/getAboutById", {
          id: this.branchId,
          lang: this.lang
        }).then(res => {
          if (res.response_code == 200) {
            this.$store.dispatch("About/setFormAbout", res.result);
          } else {
            console.log('data not found');
          }
        });
        await this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
        // loaded
        this.isLoading = false;
        let name = Utils.getBranchNameById(this.branchId, this.allBranches);
        this.$router.push(`/${this.lang}` + `/${name}/about#network`);
      }
      if (website) {
        // loaded
        this.isLoading = false;
        window.open(website);
      }
      if (path) {

        // loading
        this.isLoading = true;

        // already use routePush function check
        // if (this.$route.path != path) {
        if (path.indexOf('/service') > -1) {
          if (branch) {
            await this.$store.dispatch("Branch/getBranchById", branch);
            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", { branch_id: branch, lang: this.lang })
          } else {
            await this.$store.dispatch("Branch/getBranchById", this.branchId);
            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", { branch_id: this.branchId, lang: this.lang })
          }
        }

        if (path == '/service/resource-center/e-book') {
          this.$store.dispatch('Article/onGetAllEbooks', { page: 1, lang: this.lang }).then(() => {
            routerPush(path);
          });

        } else if (path == '/service/resource-center/article') {
          this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang }).then(() => {
            routerPush(path);
          });

        } else if (path == '/service/resource-center/online-exhibition') {
          this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang }).then(() => {
            routerPush(path);
          });

        } else if (path == '/service/resource-center/design-world-calendar') {
          this.$store.dispatch('Program/onGetDesignWorldCalendar', { lang: this.lang }).then(() => {
            routerPush(path);
          });

        } else if (path == '/faqs') {
          this.$store.dispatch('Faq/onGetAllFaqs', this.lang).then(() => {
            routerPush(path);
          });

        } else if (path.includes('home')) {
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
            branch_id: branch,
            lang: this.lang
          });
          this.$store.dispatch("Branch/getBranchById", branch).then(() => {
            routerPush(path, branch);
          });

        } else if (path.indexOf('/about') > -1) {
          await this.$store.dispatch("About/getAboutById", {
            id: branch,
            lang: this.lang
          }).then(res => {
            if (res.response_code == 200) {
              this.$store.dispatch("About/setFormAbout", res.result);
            } else {
              console.log('data not found');
            }
          });
          if (branch === 5) {
            await this.$store.dispatch('Branch/getMiniByBranch', { branch_id: branch, lang: this.lang });
          }
          await this.$store.dispatch("Branch/getBranchById", branch);
          await this.$store.dispatch("About/getAboutAllMenu", { branch_id: branch, lang: this.lang });
          routerPush(path, branch);

        } else {
          let newPath = path
          let tagFromMenu = ''
          for (const b of this.allBranches) {
            if (branch === b.branch_id) tagFromMenu = b.tag_name
          }
          if (path == '/resource-center') newPath = `/${tagFromMenu}/service/resource-center`
          if (path == '/visit-and-service-area') newPath = `/${tagFromMenu}/service/visit-and-service-area`
          routerPush(newPath, this.branchId);
          this.$router.go()
        }

        // }
        return;
      }
    },
    socialClick(social) {
      switch (social.name) {
        case 'youtube':
        case 'facebook':
        case 'line':
        case 'twitter':
          window.open(social.link);
          break;
      }
    },
    gotoPolicy(path) {
      window.open(path, '_blank');
    }
  },
  data: () => ({
    menus: [],
    social: [
      {
        icon: require('../../assets/icons/social/youtube.png'),
        name: 'youtube',
        link: 'https://www.youtube.com/user/TCDCThailand'
      },
      {
        icon: require('../../assets/icons/social/facebook.png'),
        name: 'facebook',
        link: 'https://www.facebook.com/tcdc.thailand'
      },
      {
        icon: require('../../assets/icons/social/twitter.png'),
        name: 'twitter',
        link: 'https://x.com/tcdc'
      },
      {
        icon: require('../../assets/icons/social/line.png'),
        name: 'line',
        link: 'https://line.me/ti/p/~@TCDC'
      }
    ],
    ref_logo: [
      {
        icon: require('../../assets/icons/logo-opm.png'),
        name: 'gov'
      },
      {
        icon: require('../../assets/icons/logo-cea.png'),
        name: 'cea'
      },
      {
        icon: require('../../assets/icons/tcdc-logo.png'),
        name: 'tcdc'
      }
    ],
    policyTh: [
      {
        link: 'https://www.cea.or.th/th/privacy-notice',
        name: 'Privacy Notice'
      },
      {
        link: 'https://www.cea.or.th/th/privacy-policy',
        name: 'Privacy Policy'
      },
      {
        link: 'https://www.cea.or.th/th/term-of-use',
        name: 'Term of Use'
      },
      {
        link: 'https://www.cea.or.th/th/security-policy',
        name: 'Security Policy'
      }
    ],
    policyEn: [
      {
        link: 'https://www.cea.or.th/en/privacy-notice',
        name: 'Privacy Notice'
      },
      {
        link: 'https://www.cea.or.th/en/privacy-policy',
        name: 'Privacy Policy'
      },
      {
        link: 'https://www.cea.or.th/en/term-of-use',
        name: 'Term of Use'
      },
      {
        link: 'https://www.cea.or.th/en/security-policy',
        name: 'Security Policy'
      }
    ]
  }),
  mounted() {
    // console.log("test", this.lang)
    this.$nextTick(() => {
      this.loadDynamicMenusWithBranch();
    })
  },
  components: {
    FooterMainMenuCard,
    FooterMenuCard,
    GreenButton
  },
  computed: {
    ...mapState({
      menuList: state => {
        if (state.Branch.branches.length > 0) {
          let mini = state.Branch.branches.find(item => item.branch_id === 5);
          let exceptMini = state.Branch.branches.filter(item => item.branch_id !== 5);
          let sorted = [
            ...exceptMini,
            mini
          ]
          return [
            ...sorted.map(branch => ({
              title_th: branch.branch_name_th,
              title_en: branch.branch_name_en,
              menuNameList: [
                ...branch.menu.map(menu => ({
                  branch_id: menu.branch_id,
                  name_th: menu.title_th,
                  name_en: menu.title_en,
                  path: menu.slug_url,
                  subMenuList: [
                    ...menu.sub_menu.map(subMenu => ({
                      branch_id: menu.branch_id,
                      name_th: subMenu.title_th,
                      name_en: subMenu.title_en,
                      path: subMenu.slug_url,
                    }))
                  ]
                }))
              ],
            }))
          ];
        }
      },
      siteMenu: state => {
        if (state.Branch.siteMenu) {
          return state.Branch.siteMenu;
        }
      },
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      serviceTopic: state => {
        return [
          ...state.Membership.memberships.map(membership => ({
            title: membership.title,
            content: membership.description,
          }))
        ]
      }
    }),
    routeChanged: function () {
      return this.$route.path
    }
  },
  watch: {
    routeChanged: async function () {

      this.loadDynamicMenusWithBranch();
    },
    lang() {
      // console.log("test2", this.lang)
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-app-bar-footer {
  width: 100vw;
}

.footer-tcdc-logo {
  height: 60px;
  object-fit: contain;
}

.newsletter-label-max-width {
  max-width: 250px;
}

.tcdc-footer-border-green {
  border-bottom: 2px solid white;
}

.card-minus-margin {
  margin-right: -28px;
}

.v-application a {
  color: white !important;
}

.v-application a:hover {
  color: #2E8037 !important;
}
</style>
